export enum LabelTypes {
  S = '0',
  M = '1',
  L = '2'
}
